import { call, put } from 'redux-saga/effects';
import {
  fetchDefaultTaxRatesFailure,
  fetchDefaultTaxRatesSuccess,
} from '../actions';
import { ApiError } from 'store/api/types';
import { FetchDefaultTaxRatesRequestAction } from '../types';
import { checkResponse } from 'store/utils';
import { GetDefaultTaxRatesResponse, getDefaultTaxRates } from '../api';
import { DefaultTaxRatesData } from '../models/defaultTaxRates';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* fetchDefaultTaxRatesSaga(
  action: FetchDefaultTaxRatesRequestAction
) {
  try {
    let err: ApiError | null;
    const { returnTypeId, connectionId } = action.payload;

    const response: GetDefaultTaxRatesResponse = yield call(
      getDefaultTaxRates,
      returnTypeId,
      connectionId
    );

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    const defaultTaxRatesData: DefaultTaxRatesData = response.data;

    yield put(fetchDefaultTaxRatesSuccess(defaultTaxRatesData));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(fetchDefaultTaxRatesFailure());
  }
}
